export const sanitizePreviewHtml = (html: string): string => {
  return html;
};
